import { BonusType } from '@superbet-group/web.types';
import BonusCategory from '@core/models/bonus/BonusCategory';
import { BonusStatus } from '@core/models/bonus/BonusStatus';
import { BonusConditions } from './BonusConditions';
import { BonusSubtype } from './BonusSubtype';
import { MoneyUsage } from './MoneyUsage';
import { Condition } from '@app/promotionHub/shared/types/Condition';
import BonusDescription from './BonusDescription';
import { BonusCategoryDto } from '@core/mappers/user/dtos/BalanceDto';
import { AwardingConditions } from './AwardingConditions';
import { PromoHubActionButton } from '@src/app/promotionHub/shared/types/PromoHubActionButton';

export enum BonusKind {
    Comtrade = 'Comtrade',
    Betler = 'Betler',
}

export interface ComtradeBonus {
    kind: BonusKind.Comtrade;
    id: number;
    name: string;
    bonusAwarded?: number;
    bonusAmount?: number;
    bonusItemsAwarded?: number;
    completedDate: Date;
    redeemedAmount: number;
    wageringRequirements?: number;
    wageredAmount: number;
    amountLeftToWager: number;
    acceptanceDate?: Date;
    activationDate?: Date;
    expirationDate: Date;
    type: BonusType;
    status: BonusStatus;
    category: BonusCategory;
    description: BonusDescription;
    subCategory?: BonusCategoryDto;
    bonusPotentialWin: number;
    bonusSubtype: BonusSubtype;
    pendingAmount: number;
    conditions: Condition[];
    bonusUsedAmount: number;
    bonusGainedAmount: number;
    promotionId?: number;
    provider?: string;
    bonusEligibilityDescription?: string;
    awardingConditions?: AwardingConditions[];
    priority?: number;
    totalWageredBonus?: number;
    bonusActionButton: PromoHubActionButton;
    termsAndConditionsUrl?: string;
}

export interface BetlerBonus {
    kind: BonusKind.Betler;
    id: string;
    name: string;
    bonusAwarded: number;
    bonusAmount?: number;
    redeemedAmount?: number;
    wageringRequirements?: number;
    wageredAmount: number;
    amountLeftToWager: number;
    acceptanceDate?: Date;
    activationDate?: Date;
    expirationDate: Date;
    completedDate: Date;
    type: BonusType;
    status: BonusStatus;
    category: BonusCategory;
    committed?: number;
    bonusConditions?: BonusConditions;
    bonusSubtype: BonusSubtype;
    bonusPotentialWin: number;
    pendingAmount: number;
    moneyUsage: MoneyUsage;
    bonusUsedAmount: number;
    bonusGainedAmount: number;
    priority?: number;
    bonusAmountLeft: number;
    rewardAmount: number;
    rewardType: string;
    bonusActionButton: PromoHubActionButton;
    termsAndConditionsUrl?: string;
    offerDetails?: string;
}

export type Bonus = ComtradeBonus | BetlerBonus;

export function isComtradeBonus(bonus: Bonus): bonus is ComtradeBonus {
    return bonus.kind === BonusKind.Comtrade;
}
